var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-calendar-wrapper"},[_c('Title',{attrs:{"title":"マイカレンダー","icon":"calendar-1"}}),_c('MyCalendar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }